<template>
  <div class="contentPage errorTips">
    <div class="imgBox">
      <img src="../../assets/images/linkInvalid.jpg" alt="">
      <p>链接已失效</p>
    </div>
  </div>
</template>

<script>

import {
  Loading, Toast, Dialog, Button
} from 'vant';
export default {
  components: {
    [Loading.name]: Loading,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
  },
  data() {
    return {
    };
  },
  created() {
  },

  methods: {

  }
};
</script>

<style lang="scss" scoped>
.errorTips {
  background: #fff;

  .imgBox {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -140px;
    margin-left: -80px;

    img {
      height: 160px;
      width: 160px;
    }

    p {
      text-align: center;
      font-size: 14px;
      color: #787878;
    }
  }
}
</style>
